import { inject } from "aurelia-framework";
import { ProcoreCustomAttribute } from "pages/procore/custom attributes/procore-custom-attribute";

@inject(Element)
export class SelectedCustomAttribute extends ProcoreCustomAttribute {
  constructor(element: any) {
    super(element, "selected");
  }
}
